export const GET_ROLE_LIST_REQUEST = "GET_ROLE_LIST_REQUEST"
export const GET_ROLE_LIST_SUCCESS = "GET_ROLE_LIST_SUCCESS"
export const GET_DEFALT_PATH_REQUEST = "GET_DEFALT_PATH_REQUEST"
export const GET_DEFALT_PATH_SUCCESS = "GET_DEFALT_PATH_SUCCESS"